module.exports = __webpack_public_path__ + "static/WEDDING E&M-590-68bbb99738839911a25e8e58498dcb77.jpg";